import { Button, Form, Input, Modal, Select, Space, Switch } from 'antd';
import React, { useState } from 'react';
import {
  AOS_VALIDATION_MESSAGES,
  POD_TYPES,
} from '../../../../common/constants';
import CommonSelect from '../../../../components/CommonSelect';
import { USERS } from '../graphql/Queries';

function PodModal({ form, open, editRecord, loading, onFinish, onCancel }) {
  const [podLeadSearch, setPodLeadSearch] = useState('');

  const podLeadOptions = editRecord?.podLead
    ? [
        {
          id: editRecord.podLeadId,
          displayName: `${editRecord.podLead.firstName} ${editRecord.podLead.lastName}`,
        },
      ]
    : [];

  return (
    <Modal
      title={editRecord ? 'Edit Pod' : 'New Pod'}
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      afterClose={() => {
        form.resetFields();
        setPodLeadSearch('');
      }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label="Pod Name"
          rules={[
            {
              required: true,
              message: AOS_VALIDATION_MESSAGES.POD_NAME_REQUIRED,
            },
          ]}
        >
          <Input placeholder="Name" maxLength={255} />
        </Form.Item>
        <Form.Item
          name="type"
          label="Type"
          rules={[
            {
              required: true,
              message: AOS_VALIDATION_MESSAGES.POD_TYPE_REQUIRED,
            },
          ]}
        >
          <Select options={POD_TYPES} placeholder="Select Type" />
        </Form.Item>
        <Form.Item
          name="podLeadId"
          label="Pod Lead"
          rules={[
            {
              required: true,
              message: AOS_VALIDATION_MESSAGES.POD_LEAD_REQUIRED,
            },
          ]}
        >
          <CommonSelect
            placeholder="Select Lead"
            showSearch
            allowClear
            query={USERS}
            responsePath="users.users"
            valuePath="id"
            labelPath="displayName"
            customOptions={podLeadOptions}
            conditionToCheckBeforeQuery={open}
            onSearch={setPodLeadSearch}
            variables={{
              filters: {
                searchStrings: podLeadSearch ? [podLeadSearch] : [],
              },
            }}
            useEffectDeps={[podLeadSearch]}
          />
        </Form.Item>
        {editRecord && (
          <Form.Item name="isActive" label="Active" valuePropName="checked">
            <Switch />
          </Form.Item>
        )}
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              {editRecord ? 'Save' : 'Create'}
            </Button>
            <Button onClick={onCancel}>Cancel</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default PodModal;
